import type { PlacementGroup } from '@/modules/adv/ad-service'
import { type AdProvidersSettings, AdProviderTypes, type GameDistributionsSettings } from '@/types'

import { DEFAULT_AD_UNIT_TIMEOUT } from './constants'

export const getGameDistributionAdSettings = (
    gameDistributionGameId: string | undefined,
): PlacementGroup<AdProvidersSettings>[] => [
    {
        placements: ['*'],
        settings: [
            {
                type: AdProviderTypes.GAME_DISTRIBUTION,
                options: { timeout: DEFAULT_AD_UNIT_TIMEOUT, gameId: gameDistributionGameId },
            } satisfies GameDistributionsSettings,
        ],
    },
]
